<template>
  <div id="app">
    <div v-if="isRedirectPage"></div>
    <router-view v-else/>
  </div>
</template>

<script>
import { isIos, isAndroid, isHarmonyOS, isPc } from './utils/env';

export default {
  data() {
    return {
      forbiddenHostname: ['jr.jddinnovation.com', 'jdfinance.com', 'jrvip.jd.com', 'vip.jr.jd.com']
    }
  },
  computed: {
    isRedirectPage() {
      if ((isIos() || isAndroid() || isHarmonyOS()) && !isPc()) {
        return true
      } else if (isPc() && this.forbiddenHostname.includes(window.location.hostname)) {
        return true
      } else {
        return false
      }
    }
  }, 
  mounted() {
    if ((isIos() || isAndroid() || isHarmonyOS()) && !isPc()) {
      window.location.replace('https://eco.jr.jd.com/common-growth-page/index.html?channel=h5B03_JRPCGW')
    } else if (isPc() && this.forbiddenHostname.includes(window.location.hostname)) {
      window.location.replace('https://jr.jd.com/')
    }
  }
}
</script>

<style>
*{
  margin: 0;
  padding: 0;
}
  #app {
    font-family: PingFang SC;
    height: 100%;
    width: 100%;
  }
</style>
